import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { config } from "../../../style";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import TextToggle from "../../../components/TextToggle";

const DisplayField = ({ label, type, text, date, timezone, location, seat, element, prepareData = () => {} }) => {
    const boxStyle = {
        display: "inline-flex",
        VerticalAlign: "text-bottom",
        BoxSizing: "inherit",
        textAlign: "left",
        AlignItems: "center",
        fontSize: "15px",
    };

    const showMoreTextRef = useRef();
    const leftRef = useRef();
    const rightRef = useRef();

    useEffect(() => {
        const leftData = leftRef.current?.innerText;
        const rightData = rightRef.current?.innerText;
        prepareData(leftData, {
            value: type === "ShowMoreText" ? element : rightData,
            type: type,
        });
    }, [text, label, type, location, element]);

    return (
        <Box sx={{ marginTop: "10px", background: "#FFFFFF", border: "1px solid #E9E9E9", borderRadius: "6px" }}>
            <Grid container>
                <Grid
                    ref={leftRef}
                    item
                    xs={12}
                    sm={2}
                    sx={{
                        borderRight: { xs: "unset", sm: "1px solid #E9E9E9" },
                        borderBottom: {
                            // xs: "1px solid #E9E9E9",
                            xs: "unset",
                        },
                        padding: { xs: "0.5rem 0.5rem 0", sm: "0.5rem" },
                    }}>
                    <Typography variant="paraText6" color={config.grayColor}>
                        {label}
                    </Typography>
                </Grid>

                {/* new types */}
                {type === "LocationTime" && (
                    <Grid
                        ref={rightRef}
                        item
                        sm={10}
                        xs={12}
                        sx={{ padding: { xs: "0rem 0.5rem 0.5rem", sm: "0.5rem" } }}>
                        <Box sx={boxStyle}>
                            {location && (
                                <Box sx={{ ...boxStyle, mr: "10px", minWidth: "30px" }}>
                                    <span>{location}</span>
                                </Box>
                            )}

                            {date && (
                                <AccessTimeIcon
                                    fontSize="small"
                                    sx={{
                                        color: "#F97316",
                                        // ml: "1rem",
                                        width: "15px",
                                        mt: "1px",
                                        mr: "4px",
                                    }}></AccessTimeIcon>
                            )}
                            {date && <span>{date}</span>}

                            {timezone && <span style={{ marginLeft: "5px" }}>{timezone}</span>}
                        </Box>
                    </Grid>
                )}
                {type === "Text" && (
                    <Grid
                        ref={rightRef}
                        item
                        sm={10}
                        xs={12}
                        sx={{ padding: { xs: "0rem 0.5rem 0.5rem", sm: "0.5rem" } }}>
                        <Box sx={boxStyle}>
                            <div dangerouslySetInnerHTML={{ __html: text }} />
                        </Box>
                    </Grid>
                )}
                {type === "ShowMoreText" && (
                    <Grid
                        ref={rightRef}
                        item
                        sm={10}
                        xs={12}
                        sx={{ padding: { xs: "0rem 0.5rem 0.5rem", sm: "0.5rem" } }}>
                        <Box sx={{ ...boxStyle, width: "100%" }} ref={showMoreTextRef}>
                            <TextToggle
                                parentRef={showMoreTextRef}
                                text={element}
                                maxLines={2}
                                buttonSx={{
                                    textDecoration: "none",
                                }}></TextToggle>
                        </Box>
                    </Grid>
                )}
                {/* for node */}
                {type === "Element" && (
                    <Grid
                        ref={rightRef}
                        item
                        sm={10}
                        xs={12}
                        sx={{ padding: { xs: "0rem 0.5rem 0.5rem", sm: "0.5rem" } }}>
                        <Box sx={{ ...boxStyle }}>{element}</Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default DisplayField;
